import { ArrowUpRight } from "lucide-react";
import { BRAND, CONTACT, NAV_LINKS, SISTER_CONCERNS } from "../lib/constants";

export const Footer = () => {
  const year = new Date().getFullYear();

  const handleNav = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#061426] text-white pt-20 pb-10 overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-[#C8A24A]/15">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <img
                src={BRAND.logo}
                alt="Sardaar Stevedoring"
                className="h-16 w-16 object-contain bg-white p-2"
              />
              <div>
                <div className="font-serif text-2xl tracking-wide">SARDAAR</div>
                <div className="font-sans text-[#C8A24A] text-[11px] tracking-widest-2 uppercase">
                  Stevedoring · Pvt. Ltd.
                </div>
              </div>
            </div>
            <p className="font-sans text-white/60 max-w-md text-[15px] leading-relaxed">
              A venture born of the Sardar Roadlines legacy — bringing five decades
              of cargo handling, transport and port operations expertise to the
              shores of Eastern India.
            </p>
            <p className="mt-6 font-serif italic text-[#C8A24A]/90 text-sm">
              In remembrance of our founder, Late Shri Narahari Nayak — Nari Sardar.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="font-sans text-xs uppercase tracking-widest-2 text-[#C8A24A] mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => handleNav(l.id)}
                    className="font-sans text-white/75 hover:text-[#C8A24A] transition-colors text-sm flex items-center gap-2 group"
                  >
                    <span>{l.label}</span>
                    <ArrowUpRight
                      size={14}
                      className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
                    />
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-sans text-xs uppercase tracking-widest-2 text-[#C8A24A] mb-5">
              Reach Us
            </div>
            <address className="not-italic font-sans text-white/75 text-sm leading-relaxed mb-4">
              {CONTACT.address}
            </address>
            <div className="space-y-1 font-sans text-sm">
              {CONTACT.phones.map((p) => (
                <a
                  key={p}
                  href={`tel:${p.replace(/\s/g, "")}`}
                  className="block text-white/85 hover:text-[#C8A24A]"
                >
                  {p}
                </a>
              ))}
              <a
                href={`mailto:${CONTACT.email}`}
                className="block text-white/85 hover:text-[#C8A24A]"
              >
                {CONTACT.email}
              </a>
            </div>

            <div className="mt-8">
              <div className="font-sans text-xs uppercase tracking-widest-2 text-[#C8A24A] mb-3">
                Group of Companies
              </div>
              <div className="font-serif italic text-white/65 text-sm leading-relaxed">
                {SISTER_CONCERNS.join(" · ")}
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-sans text-white/45 text-xs">
            © {year} {BRAND.name}. All rights reserved.
          </p>
          <p className="font-sans text-white/35 text-xs italic">
            Crafted with discipline, in honour of a 55-year legacy.
          </p>
        </div>
      </div>
    </footer>
  );
};
